function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.09,9.6l1.08,1.08,1.06-1.06L25,6.42,24,7.48,25,8.54l-1.68,1.61a11.21,11.21,0,0,0-6.6-2.71V6.7h.78a1.51,1.51,0,0,0,1.08-.47,1.48,1.48,0,0,0,.44-1.08V3.62a1.51,1.51,0,0,0-.47-1.08A1.37,1.37,0,0,0,17.5,2.1h-3A1.6,1.6,0,0,0,13,3.5s0,.1,0,.15V5.18a1.51,1.51,0,0,0,.47,1.08,1.49,1.49,0,0,0,1.06.44h.77v.74a11.26,11.26,0,1,0,9.17,3.77ZM14.45,5.15V3.65h3.1L17.5,5.2Zm11.3,13.5A9.75,9.75,0,1,1,16,8.9,9.76,9.76,0,0,1,25.75,18.65Zm-7.87,0a1.88,1.88,0,1,1-2.63-1.72V11.85h1.5v5.08A1.88,1.88,0,0,1,17.88,18.65Z",
  fill: "#33ba69"
});

var SvgCounterIcon = function SvgCounterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCounterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/counter_icon.d34d14bb.svg";
export { ForwardRef as ReactComponent };